/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetCustomActionQuery } from "~/generated/graphql";

type Props = {
  customActionId: string;
};

export function useGetCustomAction({ customActionId }: Props) {
  const { data, loading, error } = useGetCustomActionQuery({
    variables: { customActionId },
  });

  return { customAction: data?.action ?? undefined, loading, error } as const;
}
